export const GetChemicalRecords = (id,skip,take) => {//alert("GetChemicalRecords")
  skip = skip ? skip : 0
  take = take ? take : 10
  return $.get('LogTemplate/GetMinLogTemplateEntry?IsActive=true&skip=null&take=null&locationId='+id)

}
export const GetLocations = () => {//alert("GetLocations")
  return $.get('Location/GetLocations?havingPools=true')
}
export const AddChemicalRecord = (model) => {
  return $.ajax({
    url: 'LogTemplate/AddLogTemplateEntry',
    data: JSON.stringify(model),
    contentType: 'application/json',
    cache: false,
    type: 'POST'
  })
}
export const UpdateChemicalRecord = (model) => {
  return $.ajax({
    url: 'LogTemplate/UpdateLogTemplateEntry',
    data: JSON.stringify(model),
    contentType: 'application/json',
    cache: false,
    type: 'POST'
  })
}
export const GetChemicalRecordDetails = (id) => {
  var x = $.get('LogTemplate/GetLogTemplateEntryWRTPoolsById?Id='+id)
  return x
}
export const GetChemicalChecklistDetails  = (id) => {//alert("GetChemicalChecklistDetails")
  return $.get('Chemical/GetChemicalChecklistDetails?chemicalChecklistId='+id)
}
export const GetChemicalChecklist  = (id) => {//alert("GetChemicalChecklist")
  return $.get('LogTemplate/GetMinLogTemplates?IsActive=null&skip=null&take=null&locationId='+id)
}
export const GetLogTemplateById  = (id) => {//alert("GetLogTemplateById")
  return $.get('LogTemplate/GetLogTemplateWRTPoolsById?Id='+id)
}
export const GetLocationPools = () => {//alert("GetLocationPools")
  return $.get('Location/GetLocationPools')
}
export const GetPools = (locationid) => {//alert("GetPools")
  return $.get('Pool/GetPools?locationId='+locationid)
}
export const GetStandards = (locationid) => {//Salert("GetStandards")
  return $.get('Chemical/GetStandards?LocationId='+locationid)
}
export const DeleteChemicalRecord = (Id) => {
  return $.post('LogTemplate/DeleteLogTemplateEntry?Id='+Id)
}


// WEBPACK FOOTER //
// ./src/components/ChemicalRecord/chemicalrecord.service.js